export default function ForBusinessOwners() {
  return (
    <section id="for-business-owners" className="py-16 md:py-[110px]">
      <div className="max-w-[1120px] mx-auto px-5 md:px-10">
        <h2 className="text-[24px] md:text-[30px] font-semibold text-[#1E2430] mb-[14px]">
          For Business Owners
        </h2>
        
        <div>
          <p className="text-[17px] leading-[1.65] text-[#5B6475] max-w-[720px] mb-6">
            We recognize that selling a business is both a financial and personal decision.
          </p>
          
          <p className="text-[17px] leading-[1.65] text-[#5B6475] max-w-[720px] mb-6">
            Valaxis Group partners with owners seeking:
          </p>
          
          <ul className="space-y-3 mb-6">
            <li className="flex items-start gap-3">
              <span className="text-[#2E3A59] mt-1">•</span>
              <span className="text-[17px] leading-[1.65] text-[#5B6475]">
                Thoughtful transition solutions
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-[#2E3A59] mt-1">•</span>
              <span className="text-[17px] leading-[1.65] text-[#5B6475]">
                Preservation of organizational legacy
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-[#2E3A59] mt-1">•</span>
              <span className="text-[17px] leading-[1.65] text-[#5B6475]">
                Long-term stewardship orientation
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-[#2E3A59] mt-1">•</span>
              <span className="text-[17px] leading-[1.65] text-[#5B6475]">
                Operational continuity
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-[#2E3A59] mt-1">•</span>
              <span className="text-[17px] leading-[1.65] text-[#5B6475]">
                Flexible deal structures
              </span>
            </li>
          </ul>
          
          <p className="text-[17px] leading-[1.65] text-[#5B6475] max-w-[720px]">
            We approach each opportunity with discretion, pragmatism, and respect for what founders and teams have built.
          </p>
        </div>

        {/* Operating Philosophy Subsection */}
        <div className="mt-[24px] pt-[24px] border-t border-[rgba(30,36,48,0.08)]">
          <h3 className="text-[24px] font-semibold text-[#1E2430] mb-[24px]">
            Operating Philosophy
          </h3>

          <div className="max-w-[720px]">
            <p className="text-[17px] leading-[1.75] text-[#5B6475] mb-6">
              Valaxis Group approaches acquisitions as long-term operating commitments rather than financial transactions.
            </p>

            <p className="text-[17px] leading-[1.75] text-[#5B6475] mb-5">
              We focus on:
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start gap-3">
                <span className="text-[#2E3A59] mt-1">•</span>
                <span className="text-[17px] leading-[1.75] text-[#5B6475]">Levaraging organizational strengths</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#2E3A59] mt-1">•</span>
                <span className="text-[17px] leading-[1.75] text-[#5B6475]">Supporting management teams</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#2E3A59] mt-1">•</span>
                <span className="text-[17px] leading-[1.75] text-[#5B6475]">Investing in scalable infrastructure</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#2E3A59] mt-1">•</span>
                <span className="text-[17px] leading-[1.75] text-[#5B6475]">Driving disciplined operational improvement</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#2E3A59] mt-1">•</span>
                <span className="text-[17px] leading-[1.75] text-[#5B6475]">Building durable enterprise value</span>
              </li>
            </ul>

            <p className="text-[17px] leading-[1.75] text-[#5B6475]">
              Our perspective is shaped by decades of executive leadership experience, emphasizing pragmatic decision-making, operational rigor, and sustainable growth.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
